<template>
  <v-card class="rounded-b-0 pt-2">
    <v-form ref="formrule">
      <div>
        <v-card-title v-for="(item, i) in querys" :key="i" class="py-1">
          <v-icon color="error" @click="delquery(i)">mdi-close</v-icon>
          <v-autocomplete
            :rules="[v => !!v || '不能为空']"
            :items="searchitem"
            v-model="item.key"
            label="搜索项目"
            class="mr-sm-5"
            dense
          ></v-autocomplete>
          <v-autocomplete
            :rules="[v => !!v || '不能为空']"
            :items="operators"
            v-model="item.operator"
            label="条件 带*的不分大小写"
            class="mr-sm-5"
            dense
          ></v-autocomplete>
          <v-text-field dense :rules="[v => !!v || '不能为空']" v-model="item.val" label="搜索内容"></v-text-field>
        </v-card-title>
      </div>
      <v-divider class="my-3" v-show="excludes.length > 0"></v-divider>
      <div>
        <v-card-title v-for="(item, i) in excludes" :key="i" class="py-1">
          <v-icon color="error" @click="delexclude(i)">mdi-close</v-icon>
          <v-autocomplete
            :rules="[v => !!v || '不能为空']"
            :items="searchitem"
            v-model="item.key"
            label="过滤项目"
            class="mr-sm-5"
            dense
          ></v-autocomplete>
          <v-autocomplete
            :rules="[v => !!v || '不能为空']"
            :items="operators"
            v-model="item.operator"
            label="条件 带*的不分大小写"
            class="mr-sm-5"
            dense
          ></v-autocomplete>
          <v-text-field dense :rules="[v => !!v || '不能为空']" v-model="item.val" label="过滤内容"></v-text-field>
        </v-card-title>
      </div>
    </v-form>
    <v-card-title class="py-1">
      <v-btn small color="info" @click="addquery"><v-icon>mdi-pencil-plus</v-icon>搜索</v-btn>
      <v-spacer></v-spacer>
      <v-btn small color="info" @click="addexclude"><v-icon>mdi-filter-plus</v-icon>过滤</v-btn>
      <v-spacer></v-spacer>
      <v-btn small color="primary" @click="searchdata">
        <v-icon>mdi-magnify</v-icon>搜索
      </v-btn>
    </v-card-title>
  </v-card>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
  data: function () {
    return {
      querys: [{ key: "", operator: "", val: "" }],
      excludes: [],
      operators: [
        { text: "包含", value: "contains" },
        { text: "*包含", value: "icontains" },
        { text: "等于", value: "exact" },
        { text: "*等于", value: "iexact" },
        { text: "大于", value: "gt" },
        { text: "大于等于", value: "gte" },
        { text: "小于", value: "lt" },
        { text: "小于等于", value: "lte" },
        { text: "以...起始", value: "startswith" },
        { text: "*以...起始", value: "istartswith" },
        { text: "以...结束", value: "endswith" },
        { text: "*以...结束", value: "iendswith" },
        { text: "在一组值内` `", value: "in" },
        { text: "空值(1是|0否)", value: "isnull" },
      ],
    };
  },
  computed: {
    searchitem() {
      return this.items.filter((item) => item.value != "actions");
    },
  },
  methods: {
    searchdata() {
      if (!this.$refs.formrule.validate()) return
      let query = "";
      let exclude = "";
      this.querys.forEach((item, index) => {
        query += item.key + "__" + item.operator + ":" + item.val + ",";
      });
      if (query.length > 0) query = query.slice(0, -1);

      this.excludes.forEach((item, index) => {
        exclude += item.key + "__" + item.operator + ":" + item.val + ",";
      });
      if (exclude.length > 0) exclude = exclude.slice(0, -1);
      this.$emit("querydata", query, exclude);
    },
    addquery() {
      this.querys.push({ key: "", operator: "", val: "" });
    },
    addexclude() {
      this.excludes.push({ key: "", operator: "", val: "" });
    },
    delquery(index) {
      this.querys.splice(index, 1);
    },
    delexclude(index) {
      this.excludes.splice(index, 1);
    },
  },
};
</script>